// The signed-in admin, kept in localStorage under "user" — the same key and
// the same auth payload the public client stores, so one API contract serves
// both apps. No axios interceptor: every authenticated call reads the session
// and sets the header itself.

const STORAGE_KEY = "user";

export const getSession = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null;
  } catch {
    return null;
  }
};

export const setSession = (session) =>
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));

export const clearSession = () => localStorage.removeItem(STORAGE_KEY);

export const isAdmin = () => getSession()?.role === "admin";

// Throws rather than sending an unauthenticated request, so the failure is
// obvious instead of arriving as a confusing 401.
export const authHeader = () => {
  const session = getSession();
  if (!session) throw new Error("Not signed in.");
  return { authorization: "Bearer " + session.token };
};
